// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1LhD4","notes":"Notes_notes__q3zJQ","note":"Notes_note__11vP3","markdown":"Notes_markdown__9hYtQ"};